import React, { useRef } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import styled from '@emotion/styled'

import uniqid from 'uniqid'
import colornames from '../../design/color-names'
import { Button, BUTTON_VARIANT_SECONDARY } from '../Button/Button'

export const TRUSTED_SMS_BOX_CODE_VARIANT_NEUTRAL = 'neutral'
export const TRUSTED_SMS_BOX_CODE_VARIANT_INVALID = 'invalid'

const StyledBoxCodeContainer = styled.div`
  margin-top: 10px;
  border: 1px solid ${colornames.geyser};
  border-radius: 4px;
  padding: 20px 10px;
`

const StyledBoxCode = styled.div`
  display: flex;
  justify-content: space-between;
`
const StyledInputCode = styled.input`
  box-sizing: border-box;
  display: inline-block;
  width: 70% !important;
  height: 36px;

  border: 1px solid ${colornames.geyser};
  border-radius: 4px;

  text-align: center;
  padding: 0 8px;
  font-size: 15px;
  line-height: 36px;
  color: ${colornames.tundora};
  background-color: ${colornames.pureWhite};

  transition: all 0.3s ease;

  &:focus {
    outline: none;
    border-color: ${colornames.geyser};
  }
`

const StyledBoxCodeLabel = styled.p`
  margin-bottom: 8px;
`
const StyledBoxCodeHint = styled.p`
  color: ${colornames.sunsetOrange};
  margin-top: 10px;
`
const StyledButton = styled(Button)`
  float: none;
  width: 20%;
`

export const TrustedSmsBoxCode = ({
  id,
  className,
  value,
  placeholder,
  onChange,
  onVerifyButtonClick,
  dataAttributeTest,
  variant,
  i18n,
  buttonVerifyDisabled,
  required
}) => {
  const { current: inputUuid } = useRef(
    id || uniqid('trusted-sms-input-boxCode-')
  )

  return (
    <StyledBoxCodeContainer
      className={className}
      data-mu-test={classnames('trusted-sms-input-boxCode', dataAttributeTest)}
    >
      <StyledBoxCodeLabel>{i18n.label}</StyledBoxCodeLabel>
      <StyledBoxCode>
        <StyledInputCode
          type='text'
          id={inputUuid}
          maxLength={4}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          variant={variant}
          required={required}
        />
        <StyledButton
          kind={BUTTON_VARIANT_SECONDARY}
          onClick={onVerifyButtonClick}
          data-mu-test='verify-button'
          disabled={buttonVerifyDisabled}
        >
          {i18n.verifyButton}
        </StyledButton>
      </StyledBoxCode>

      {variant === TRUSTED_SMS_BOX_CODE_VARIANT_INVALID && (
        <StyledBoxCodeHint>{i18n.invalid}</StyledBoxCodeHint>
      )}
    </StyledBoxCodeContainer>
  )
}

TrustedSmsBoxCode.defaultProps = {
  i18n: {
    label: 'Insert the verification code in following box:',
    verifyButton: 'verify',
    invalid: 'The verification code you entered is not valid.'
  }
}

TrustedSmsBoxCode.propTypes = {
  id: PropTypes.string,
  className: PropTypes.string,
  dataAttributeTest: PropTypes.string,
  value: PropTypes.string,
  placeholder: PropTypes.string,
  onChange: PropTypes.func,
  onVerifyButtonClick: PropTypes.func,
  variant: PropTypes.oneOf([
    TRUSTED_SMS_BOX_CODE_VARIANT_NEUTRAL,
    TRUSTED_SMS_BOX_CODE_VARIANT_INVALID
  ]),
  i18n: PropTypes.shape({
    label: PropTypes.string,
    verifyButton: PropTypes.string,
    invalid: PropTypes.string
  }),
  buttonVerifyDisabled: PropTypes.bool,
  required: PropTypes.bool
}
